const $ = require('jquery');
const pjax = require('./pjax');

module.exports = {
  init() {
    this.emailSpaces();
    const _this = this;
    $(document).on('pjax:end', () => {
      _this.emailSpaces();
    });
  },
  emailSpaces() {
    $('input[name="email"]').focusout(function () {
      let email_str = $(this).val();
      email_str = email_str.trim();
      $(this).val(email_str);
    });
  },
};
